module.exports = __webpack_public_path__ + "0ede39f56289781d4d75a4c563d59c2d.MP3";